<template lang="pug">
#wrap_sub
  .sub_right
    .content_desc
      #s61.sub
        .s6_a
          .in
            h2.s_tit
              span CONTACT
            .cont
              kakao-map
        #Contact.s6_b
          .in
            div
              .lt
                .lt_wrap
                  .service
                    div
                      h3 CS Center
                      h4 010-2982-0063
                    ul.top
                      li
                        span.bold Weekdays.
                        | 09:00 ~ 18:00
                      li
                        span.bold Lunch break.
                        | 12:00 ~ 13:00
                      li
                        | Closed during the weekends and holidays
                  .bot
                    h3 SNS
                    ul
                      li
                        a(href='https://instagram.com/inthekeg_official?igshid=1khripgblodww' target='_blank')
                          img(:src='require("../../assets/images/c_sns01.png")' alt='')
                      li
                        a(href='https://www.youtube.com/channel/UC03tOkU9J4pFxL697PMjMiQ' target='_blank')
                          img(:src='require("../../assets/images/c_sns02.png")' alt='')
              .rg
                .rg01.rg_list
                  div
                    h3 Inquiries
                      br
                      | regarding sales
                    p tei.kim@inthekeg.com
                    .ct_btn
                      a(href='mailto:tei.kim@inthekeg.com') Inquiry
                .rg02.rg_list
                  div
                    h3 Inquiries
                      br
                      | regarding partnerships
                    p info@inthekeg.com
                    .ct_btn
                      a(href='mailto:info@inthekeg.com') Inquiry
                .rg03.rg_list
                  div
                    h3 Inquiries
                      br
                      | regarding marketing
                    p info@inthekeg.com
                    .ct_btn
                      a(href='mailto:info@inthekeg.com') Inquiry
        .s6_c
          .in
            h3.s6_tit Official sales partners
            .pt
              .pt01.pt_list
                .pt_wrap
                  .pt_tit
                    span
                      img(:src='require("../../assets/images/c_logo01.png")' alt='')
                    h4 KEGBRU
                  h5 1105, 44, Mapo-daero, Mapo-gu, Seoul
                  ul
                    li
                      span.bold.yell Tel. 
                      | 02-572-3070
                    li
                      span.bold.yell E-mail. 
                      a(href='mailto:kegbru@naver.com') kegbru@naver.com
              .pt02.pt_list
                .pt_wrap
                  .pt_tit
                    span
                      img(:src='require("../../assets/images/c_logo02.png")' alt='')
                    h4 Vera Korea
                  h5 A-B104, Indeogwon IT Valley, 40, Imi-ro, Uiwang-si, Gyeonggi-do
                  ul
                    li
                      span.bold.yell Tel. 
                      | 1544-2103
                    li
                      span.bold.yell E-mail. 
                      a(href='mailto:infovera@naver.com') infovera@naver.com
              .pt03.pt_list
                .pt_wrap
                  .pt_tit
                    span
                      img(:src='require("../../assets/images/c_logo03.png")' alt='')
                    h4 Kegplace
                  h5 1F, 48, Gamasan-ro 20-gil, Guro-gu, Seoul
                  ul
                    li
                      span.bold.yell Tel. 
                      | 02) 830-3294
                    li
                      span.bold.yell E-mail. 
                      a(href='mailto:info@kegplace.com') info@kegplace.com
              .pt04.pt_list
                .pt_wrap
                  .pt_tit
                    span
                      img(:src='require("../../assets/images/c_logo04.png")' alt='')
                    h4 WIDEKEG
                  h5 B101, 121, Yeonsam-ro, Jeju-si, Jeju-do
                  ul
                    li
                      span.bold.yell Tel. 
                      | 010-2126-0545 / 010-8242-3519
                    li
                      span.bold.yell E-mail. 
                      a(href='mailto:osh199810903@nate.com') osh199810903@nate.com
                      br
                      a(href='mailto:adhouse123@hanmail.net') adhouse123@hanmail.net
        .s6_d#s6_d
          .in
            h3.s6_tit Inquiry
            #fwrite
              .form
                .t_box1.t_box
                  .i_box
                    ul
                      li
                        h5 Name
                        input.frm_input.required#wr_1(type='text' v-model='askData.name' value='' title='이름')
                      li
                        h5 Tel
                        input.frm_input.requiredwr_2(type='text' v-model='askData.mobile' value='' title='연락처')
                      li
                        h5 E-mail
                        input.frm_input.requiredwr_4(type='text' v-model='askData.email' value='' title='이메일')
                      li
                        h5 Content
                        .i_box
                          textarea#wr_content( v-model='askData.content'  maxlength='500' style='width:100%;height:300px')
                    .bop_check
                      label
                        input#agree1(type='checkbox' v-model='checkAgree')
                        span.protxt Agree to collect and use personal information 
                      a(@click='modal("privacy")') [Checking the Privacy Policy]
                    .board_btn
                      button#btn_submit(@click='sendQuery()') Confirm

</template>

<script>
import { mapGetters } from 'vuex';
import KakaoMap from './KakaoMap.vue';
export default {
  components: {
    'kakao-map': KakaoMap,
  },
  data() {
    return {
      askData: {
        name: '',
        mobile: '',
        email: '',
        content: '',
        nation: '',
      },
      checkAgree: false,
      remainTime: null,
      tokenChecker: null,
    };
  },
  computed: {
    ...mapGetters(['lan']),
  },
  methods: {
    sendQuery() {
      if (!this.askData.name) {
        alert('Please enter your name.');
      } else if (!this.askData.mobile) {
        alert('Please enter your tel.');
      } else if (!this.askData.email) {
        alert('Please enter your email.');
      } else if (!this.askData.content) {
        alert('Please enter your content.');
      } else {
        if (this.askData.content.length > 500) {
          alert('The number of inquiry content letters has exceeded.');
          return;
        }
        if (this.checkAgree) {
          this.askData.nation = this.lan;
          this.$_axios('POST', 'board/contact', this.askData).then(res => {
            if (res) {
              alert('The inquiry has been received. Thank you.');
            } else {
              alert('Registration of inquiry failed.');
              return;
            }
          });
          this.askData = {
            name: '',
            mobile: '',
            email: '',
            content: '',
          };
          this.checkAgree = !this.checkAgree;
        } else {
          alert('Please agree to collect and use personal information.');
        }
      }
    },
    modal(name) {
      window.open(name, name, 'width=600,height=400,scrollbars=yes');
    },
  },
};
</script>
<style scoped>
@import '../../assets/css/contact-fir.css';
@import '../../assets/css/contact-sec.css';
@import '../../assets/css/en/en_default.css';
label .protxt {
  margin-left: 5px;
}
@media (max-width: 768px) {
  .form .i_box ul li input {
    min-width: 100%;
  }
}
</style>
